import { useIsFetching } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Glyphicon } from 'react-bootstrap';
import { PRICING_RULES_BASE_QUERY_KEY } from 'components/domain/propertyPricing/pricingRulesQuery';
import SectionHeader from 'components/sectionHeader/SectionHeader';
import Button from 'components/button/Button';
import PropertyEditActionWrapper from 'pages/property/common/PropertyEditActionWrapper';
import PermissionsAwareFieldset from '../../../common/PermissionsAwareFieldset';
import PriceRulesOverrideAirbnb from './PriceRulesOverrideAirbnb';
import PriceRulesTable from './PriceRulesTable';
import usePriceRulesAddEditModal from './modals/usePriceRulesAddEditModal';

const PriceRules = () => {
  const { t } = useTranslation();
  const { openAddPriceRulesModal } = usePriceRulesAddEditModal();
  const amountOfPriceRulesQueries = useIsFetching({
    queryKey: [PRICING_RULES_BASE_QUERY_KEY],
  });
  const isFetchingPriceRules = amountOfPriceRulesQueries > 0;

  return (
    <section data-testid="price-rules-section">
      <PermissionsAwareFieldset>
        <SectionHeader
          id="price-rules-header"
          title={t('pageProperty.pricing.priceRules.title')}
          buttons={
            <PropertyEditActionWrapper tooltipId="price-rules-header-button-tooltip">
              <Button
                bsStyle="primary"
                data-testid="price-rules-header-button"
                disabled={isFetchingPriceRules}
                onClick={openAddPriceRulesModal}
              >
                <Glyphicon glyph="plus" />
                {t('pageProperty.pricing.priceRules.addPriceRule')}
              </Button>
            </PropertyEditActionWrapper>
          }
          tooltip={t('pageProperty.pricing.priceRules.tooltip')}
        />
        <PriceRulesOverrideAirbnb />
        <PriceRulesTable />
      </PermissionsAwareFieldset>
    </section>
  );
};

export default PriceRules;
